import * as awin from './awin'
import * as commissionJunction from './commission-junction'
import * as everflow from './everflow'
import * as fortell from './fortell'
import * as generic from './generic'
import * as impact from './impact'
import * as partnerize from './partnerize'
import * as skimlinks from './skimlinks'
import type { Network } from './types'
import * as yeshearing from './yeshearing'

// Order matters — first match wins. Generic is the fallback (always matches).
const networks: Network[] = [
  impact,
  yeshearing,
  awin,
  commissionJunction,
  skimlinks,
  partnerize,
  everflow,
  fortell,
  generic,
]

const findNetwork = (hostname: string): Network | undefined => networks.find((network) => network.match(hostname))

export const getNetworkTrackingConfig = (
  hostname: string
): { compactTracking: boolean; maxTrackingLength?: number } => {
  const network = findNetwork(hostname)
  return {
    compactTracking: network?.compactTracking ?? false,
    maxTrackingLength: network?.maxTrackingLength,
  }
}

export const applyNetwork = (url: URL, params: import('./types').NetworkParams): void => {
  const network = findNetwork(url.hostname)
  network?.apply(url, params)
}

export type { NetworkParams } from './types'
